module.exports = __webpack_public_path__ + "img/photo_2023-11-19 17.43.58.1df15a81.jpg";